import React from "react";
import Loader from "./Loader";

const Card = ({ title, value, children, loading }) => {
  return (
    <>
      <div className="rounded-sm border bg-white py-6 pl-8 pr-32 shadow-md">
        <div className="flex items-center justify-center rounded-full h-11 bg-[rgb(239_242_247_/_var(--tw-bg-opacity))] w-12">
          {children}
        </div>

        <div className="mt-4 flex items-end justify-between">
          <div>
            <h4 className="text-[24px] font-bold text-black">
              {loading ? (
                <Loader
                  className="my-[10%] ml-1"
                  insideClasses="w-[22px] h-[22px] border-2"
                />
              ) : (
                value
              )}
            </h4>
            <span className="text-sm font-medium text-[gray]">{title}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
